/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// @mui material components
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import { Icon } from '@mui/material';
import { Link } from 'react-router-dom';
// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

function HorizontalTeamCard({
  image,
  name,
  titles,
  position,
  description,
  profileLink,
}) {
  return (
    <Card sx={{ mt: 3 }}>
      <Grid container>
        <Grid item xs={12} md={6} lg={4} sx={{ mt: -6 }}>
          <MKBox width='100%' pt={2} pb={1} px={2}>
            <MKBox
              component='img'
              src={image}
              alt={name}
              width='100%'
              sx={{ objectFit: 'contain' }}
              borderRadius='md'
              shadow='lg'
            />
          </MKBox>
        </Grid>
        <Grid item xs={12} md={6} lg={8} sx={{ my: 'auto' }}>
          <MKBox
            pt={{ xs: 1, lg: 2.5 }}
            pb={2.5}
            pr={4}
            pl={{ xs: 4, lg: 1 }}
            lineHeight={1}
          >
            <MKTypography color='warning' variant='h5'>
              {name}
            </MKTypography>
            <MKTypography variant='body2' color='black' opacity={0.85}>
              {titles}
            </MKTypography>
            <MKTypography
              textGradient
              variant='h6'
              color={position.color}
              mb={1}
            >
              {position.label}
            </MKTypography>
            <MKTypography variant='body2' color='text'>
              {description}
            </MKTypography>
            <MKTypography
              component={Link}
              to={profileLink}
              mt={1}
              variant='body2'
              color='error'
              fontWeight='regular'
              sx={{
                display: 'flex',
                alignItems: 'center',

                '& .material-icons-round': {
                  fontSize: '1.125rem',
                  transform: `translateX(3px)`,
                  transition:
                    'transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)',
                },

                '&:hover .material-icons-round, &:focus .material-icons-round':
                  {
                    transform: `translateX(6px)`,
                  },
              }}
            >
              Read more <Icon sx={{ fontWeight: 'bold' }}>arrow_forward</Icon>
            </MKTypography>
          </MKBox>
        </Grid>
      </Grid>
    </Card>
  );
}

// Typechecking props for the HorizontalTeamCard
HorizontalTeamCard.propTypes = {
  profileLink: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  titles: PropTypes.string.isRequired,
  position: PropTypes.shape({
    color: PropTypes.oneOf([
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'error',
      'dark',
      'light',
    ]),
    label: PropTypes.string.isRequired,
  }).isRequired,
  description: PropTypes.string.isRequired,
};

export default HorizontalTeamCard;
